import { t } from '@lingui/core/macro';
import { NoddiInfoBanner } from 'noddi-ui-web';

type Props = {
  phoneDisplay: string;
};

/**
 * Logged-out warning for a proposal whose contact has no supported mobile number:
 * the SMS sign-in the confirm step requires cannot reach that number.
 */
export const ProposalContactPhoneNotice = ({ phoneDisplay }: Props) => (
  <NoddiInfoBanner
    variant='warning'
    title={t`This proposal cannot be confirmed by SMS`}
    texts={[
      {
        value: phoneDisplay
          ? t`The phone number on this proposal (${phoneDisplay}) cannot receive SMS, so it cannot be used to sign in and confirm the booking. Contact us to change the contact number on the proposal.`
          : t`This proposal has no mobile number to sign in with, so the booking cannot be confirmed. Contact us to add a contact number to the proposal.`
      }
    ]}
  />
);
